import React, {Component} from "react";
import ReactLoading from 'react-loading';

/*
* Authentication
*/
import Alt from 'alt';
import history from '../../../history';
import axios from 'axios';
import AuthActions from '../../../actions/AuthActions';
import AuthStore from '../../../stores/AuthStore';
import routes from '../../../routes';

import ExamList from '../../../components/ExamList';
import Ecg from '../../Ecg';
import Constants from '../../../components/Constants';

import ReactTooltip from 'react-tooltip'
import Pagination from "react-js-pagination";
import {
    Badge,
    Row,
    Col,
    Button,
    Label,
    Input,

    Nav,
    NavItem,
    NavLink
} from "reactstrap";
import classnames from "classnames";

class DashboardDoctor extends Component {

    getInitialState(){
        return {
            setState: undefined
        }
    }

    constructor(props) {
      super(props);

      this.refreshExamList = this.refreshExamList.bind(this);
      this.filterExamsClick = this.filterExamsClick.bind(this);
      this.updateInputValue = this.updateInputValue.bind(this);
      this.updateCheckboxValue = this.updateCheckboxValue.bind(this);
      this.resetFilterExamsClick = this.resetFilterExamsClick.bind(this);
        
      this.state = {
        examList: null,
        activePage: 1,

        loadingList: true,
        notificationInterval: 30000,//intervalo padrão para tocar o som a cada 30 segundos

        searchFilter: {
          firstResult: 0,
          maxResults: 10,

          reportStatus: "0",
          examRegister: "",
          clientName: "",
          patientName: "",
          beginExecutionDate: "",
          endExecutionDate: "",
          beginReceptionDate: "",
          endReceptionDate: "",
          beginReportDate: "",
          endReportDate: "",
          pediatricOnly: false,
          reportSearchText: "",
          genericSearchText: "",
          lowPriorityOnly: false,
          excludeLowPriorityExams: false,
          showPardiniExams: false,
          groupId: null,
          showEcardioExams: true,
          partExams: false          
        }
      };

      if (AuthStore.getState().user.isInPardiniGroup) {
        this.state.searchFilter.showEcardioExams = false;
        this.state.searchFilter.showPardiniExams = true;
        this.state.searchFilter.partExams = true;
      }

      if (localStorage.getItem('searchFilter')) {
        const searchFilter = JSON.parse(localStorage.getItem('searchFilter'));
        this.state.searchFilter = searchFilter;
      }

      this.refreshStorageSearchFilterState();

      //Busca exames
      this.refreshExamList();
    }

    componentDidMount() {
      this.refreshExaListThread = setInterval(this.refreshExamList, 30000);
    }
    componentWillUnmount() {
      clearInterval(this.refreshExaListThread);
      clearInterval(this.notificationSoundThread);
    }

    updateInputValue(evt, input) {
      let actualSearchFilter = this.state.searchFilter;
      actualSearchFilter[input] = evt.target.value;

      this.setState({
        searchFilter: actualSearchFilter
      });
    }

    updateCheckboxValue(evt, input) {
      let actualSearchFilter = this.state.searchFilter;
      actualSearchFilter[input] = !actualSearchFilter[input];

      this.setState({
        searchFilter: actualSearchFilter
      }, function(){
        this.refreshExamList();
      });

      this.refreshStorageSearchFilterState();
    }

    refreshExamList(){
      this.setState({
        loadingList: true
      });
         
      if (AuthStore.getState().user.isInPardiniGroup) {
        let searchFilter = this.state.searchFilter;
        searchFilter.groupId = Constants.pardiniGroup
        searchFilter.partExams = true;
        this.setState({searchFilter: searchFilter, showPardiniExams: true, showEcardioExams: false});        
      }

      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/doctor/'+AuthStore.getState().user.entity_id,
          data: this.state.searchFilter
      })
      .then(response => {
          this.setState({
              examList: response.data,
              loadingList: true
          });

          if(response.data.exams && response.data.exams.length) {
            let notificationInterval = this.state.notificationInterval;

            //se a hora atual está entre 19h e 7h, configurar para tocar o som a cada 5 segundos
            const now = new Date();
            const hours = now.getHours();
            if (hours >= 19 || hours < 7) {
              notificationInterval = 5000;
  
              //se é de noite, verificar se tem exames atrasados
              //caso exames atrasados, configurar para tocar o som a cada 1 segundo
              let totalLateExams = 0;  
              
              for(var i=0; i<response.data.exams.length; i++){
                let exam = response.data.exams[i];              
                let isLate = ((((new Date() - exam.dtReceived) / 1000 / 60) * 100) / this.getReportLimit(exam)) >= 100;
                
                if(isLate) totalLateExams++;
              }

              if(totalLateExams > 0) {
                notificationInterval = 1000;  
              }

              if (notificationInterval != this.state.notificationInterval) {
                clearInterval(this.notificationSoundThread);
                this.notificationSoundThread = undefined;
    
                this.notificationSoundThread = setInterval(this.showNotificationSound, notificationInterval);
              }
              
              this.setState({
                notificationInterval: notificationInterval
              });
            } 
            else if (this.state.notificationInterval < 30000){
              // notificationInterval = 30000;
              clearInterval(this.notificationSoundThread);
              this.notificationSoundThread = undefined;   
            }
            
          } else if (this.notificationSoundThread) {
            clearInterval(this.notificationSoundThread);
            this.notificationSoundThread = undefined;            
          }
      })
      .catch(error => {
        this.setState({
          loadingList: false
        })
      });
    }

    getReportLimit(exam){
      var clientReportLimit = 0;

      if(exam.client.reportLimit > 0){
          clientReportLimit = exam.client.reportLimit;
      }else{
          if(exam.client.priority == "PRIORITY_LOW") clientReportLimit = 1440;
          if(exam.client.priority == "PRIORITY_NORMAL") clientReportLimit = 60;
          if(exam.client.priority == "PRIORITY_HIGH") clientReportLimit = 10;
          if(exam.client.priority == "PRIORITY_URGENCY") clientReportLimit = 5;
      }

      if(exam.urgent && clientReportLimit > 10){
          clientReportLimit = 10;
      }

      return clientReportLimit;
    }

    showNotificationSound() {
      document.getElementById('sound').play();
    }

    filterExamsClick(){
      this.refreshExamList();
    }

    resetFilterExamsClick(){
      var showEcardioExams = true;
      var showPardiniExams = false;
      var partExams = false;

      if (AuthStore.getState().user.isInPardiniGroup) {
        showEcardioExams = false;
        showPardiniExams = true;
        partExams = true;
      }

      this.setState({
        activePage: 1,

        searchFilter: {
          firstResult: 0,
          maxResults: 10,

          reportStatus: "0",
          examRegister: "",
          clientName: "",
          patientName: "",
          beginExecutionDate: "",
          endExecutionDate: "",
          beginReceptionDate: "",
          endReceptionDate: "",
          beginReportDate: "",
          endReportDate: "",
          pediatricOnly: false,
          reportSearchText: "",
          genericSearchText: "",
          lowPriorityOnly: false,
          excludeLowPriorityExams: false,
          showPardiniExams: showPardiniExams,
          groupId: null,
          showEcardioExams: showEcardioExams,
          partExams: partExams
        }
      }, () => {this.refreshExamList(); this.refreshStorageSearchFilterState();});
    }

    handlePageChange(pageNumber) {

        this.setState({activePage: pageNumber});

        let filter = this.state.searchFilter;
        filter.firstResult = ((pageNumber-1) * 10);
        this.setState({
            searchFilter:  filter
        }, () => this.refreshExamList());
    }

    refreshStorageSearchFilterState() {
      localStorage.setItem('searchFilter', JSON.stringify(this.state.searchFilter));
    }

    render() {
      if(this.state.examList == null) {
        if(this.state.loadingList) {
          return(
            <div style={{height:'100%'}}>
              <Row className="justify-content-center align-items-center" style={{height:'100%'}}>
                {
                  <div className="text-center">
                    <ReactLoading type={'spinningBubbles'} color={'#20a8d8'} width={'100'} height={'100'}/>
                    <br/>
                    <b className="info-label">Carregando...</b>
                  </div>                  
                }
              </Row>
            </div>
          );      
        }

        return (
          <div style={{height:'100%'}}>
            <Row className="justify-content-center align-items-center" style={{height:'100%'}}>
              <div className="text-center">
                <b className="info-label">Ocorreu um erro ao carregar os exames. <br/><br/> Verifique sua conexão ou entre em contato com o suporte.</b>
              </div>
            </Row>
          </div>
        );
      }

      return (
          <div>
            <Row>
                <Col xs="12" md="4">
                    <Input type="text" id="genericSearchText" value={this.state.searchFilter.genericSearchText}
                      onChange={evt => this.updateInputValue(evt, "genericSearchText")} placeholder="Busca Genérica"/>
                </Col>

                {
                  AuthStore.getState().user.isInPardiniGroup ?      
                    <Col xs="6" md="2">
                      <Label htmlFor="showEcardioExams"></Label>
                      <Input type="checkbox" id="showEcardioExams" value={this.state.searchFilter.showEcardioExams}
                        checked={this.state.searchFilter.showEcardioExams}
                        onChange={evt => this.updateCheckboxValue(evt, "showEcardioExams")}/> Exibir exames Ecardio
                    </Col>
                    : ''
                }

                {
                  AuthStore.getState().user.isInPardiniGroup ?                    
                    <Col xs="6" md="2">
                      <Label htmlFor="showPardiniExams"></Label>
                      <Input type="checkbox" id="showPardiniExams" value={this.state.searchFilter.showPardiniExams}
                        checked={this.state.searchFilter.showPardiniExams}
                        onChange={evt => this.updateCheckboxValue(evt, "showPardiniExams")}/> Exibir exames Pardini
                        {'\u00A0'}
                        {
                          this.state.searchFilter.showPardiniExams && this.state.examList.totalPardiniResults ? <Badge color="danger" pill>{this.state.examList.totalPardiniResults}</Badge> : ''
                        }
                    </Col>                    
                  : ''
                }

                <Col xs="4" md="2" className="text-right">
                    <Button color="primary" onClick={this.filterExamsClick.bind(this)} data-tip="Pesquisar">
                    {<i className="fa fa-search"></i>} {'\u00A0'} Pesquisar
                    </Button>
                    {'\u00A0'}
                    <Button color="warning" onClick={this.resetFilterExamsClick.bind(this)} data-tip="Limpar Filtros">
                      <i className="fa fa-times"></i>{'\u00A0'}Limpar Filtros
                    </Button>
                </Col>
              </Row>
              <br />
              <h6>Aguardando Laudo</h6>

              <ExamList examList={this.state.examList} />

              <br />
              <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.examList.totalResults}
                  pageRangeDisplayed={15}
                  onChange={this.handlePageChange.bind(this)}
              />

              <ReactTooltip />

              <audio id='sound' preload='auto'>
                <source src='sound/sound.mp3' type='audio/mpeg' />
                <source src='sound/sound.ogg' type='audio/ogg' />
                <embed hidden='true' loop='false' src='sound.mp3' />
              </audio>
          </div>
      )
    }
}

export default DashboardDoctor;



// WEBPACK FOOTER //
// ./src/views/Dashboard/doctor/DashboardDoctor.js